module.exports = __webpack_public_path__ + "static/favicon-c0db4d9d843e17aede5b2845bac12d8f.ico";